import { render, staticRenderFns } from "./AnchorLayoutBasic.vue?vue&type=template&id=5d6d9866&scoped=true"
import script from "./AnchorLayoutBasic.vue?vue&type=script&lang=js"
export * from "./AnchorLayoutBasic.vue?vue&type=script&lang=js"
import style0 from "./AnchorLayoutBasic.vue?vue&type=style&index=0&id=5d6d9866&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6d9866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6d9866')) {
      api.createRecord('5d6d9866', component.options)
    } else {
      api.reload('5d6d9866', component.options)
    }
    module.hot.accept("./AnchorLayoutBasic.vue?vue&type=template&id=5d6d9866&scoped=true", function () {
      api.rerender('5d6d9866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/AnchorLayoutBasic.vue"
export default component.exports